<template>
  <main>
    <NavMenu>
      <NavItem name="个人中心" />
      <NavItem name="机构关联" active />
    </NavMenu>
    <section class="content">
      <div class="formarea" v-loading="loading">
        <p class="tip">
          为了确保采选的真实性与可靠性，请认真填写，一旦确认则不可随意修改。
        </p>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="185px"
          class="demo-ruleForm"
        >
          <el-form-item label="机构类型：" prop="type">
            <el-select
              :disabled="checkIsChanged"
              @change="handleCustomerTypeChange"
              style="width: 100%"
              v-model="ruleForm.customertype"
              placeholder="请选择机构类型"
            >
              <el-option
                v-for="item in customerTypeData"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择机构：" prop="customercode">
            <el-select
              clearable
              :disabled="checkIsChanged"
              @change="handleCustomerChange"
              style="width: 100%"
              @focus="handleSelectFocus"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="loading"
              v-model="ruleForm.customercode"
              placeholder="请选择机构"
            >
              <el-option
                v-for="item in customerData"
                :key="item.customercode"
                :label="item.name"
                :value="item.customercode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院系/部门：" prop="deptid">
            <el-cascader
              :disabled="checkIsChanged"
              placeholder="请选择院系/部门"
              style="width: 100%"
              v-model="ruleForm.deptid"
              :options="departmentData"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                value: 'ruid',
                label: 'name',
                emitPath: false,
                multiple: false,
              }"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="院系/部门信息补充：" prop="special">
            <el-input
              v-model="ruleForm.special"
              placeholder="比如：统计学专业2000级硕士"
            ></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" prop="name">
            <el-input
              :disabled="checkIsChanged"
              v-model="ruleForm.name"
              placeholder="请输入真实姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份：" prop="useridentity">
            <el-select
              :disabled="checkIsChanged"
              style="width: 100%"
              v-model="ruleForm.useridentity"
              placeholder="请选择身份"
            >
              <el-option
                v-for="item in identifyData"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学工号/校园卡号：" prop="studentno">
            <el-input
              :disabled="checkIsChanged"
              v-model.number="ruleForm.studentno"
              placeholder="请输入学工号/校园卡号"
            ></el-input>
          </el-form-item>
          <el-form-item label="职务：" prop="position">
            <el-input
              v-model="ruleForm.position"
              placeholder="比如：副教授/馆长/学科馆员/2000级硕士等"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="contactphone">
            <el-input
              v-model="ruleForm.contactphone"
              placeholder="请输入11位手机号或区号-座机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="submit-button"
              type="primary"
              @click="submitForm('ruleForm')"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    var validateConsultphone = (rule, value, callback) => {
      var testPhone = /^(1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8})?$/
      var testFixedPhone = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
      if (value != '') {
        if (!testPhone.test(value) && !testFixedPhone.test(value)) {
          callback(new Error('联系电话格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var validateEmail = (rule, value, callback) => {
      var testEmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (value != '') {
        if (!testEmail.test(value)) {
          callback(new Error('邮箱格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      customerTypeData: [],
      customerData: [],
      cacheCustomerData: [],
      departmentData: [],
      identifyData: [
        {
          name: '图书馆员',
          value: '3',
        },
        {
          name: '院系老师',
          value: '2',
        },
        {
          name: '学生',
          value: '1',
        },
        {
          name: '其他',
          value: '0',
        },
      ],
      ruleForm: {
        ruid: '',
        type: '',
        customertype: 1,
        customercode: '',
        deptid: '',
        special: '',
        name: '',
        useridentity: '',
        studentno: '',
        position: '',
        contactphone: '',
        email: '',
        registerstep: '',
      },
      rules: {
        type: [{ required: true, message: '请选择机构类型', trigger: 'change' }],
        customercode: [{ required: true, message: '请选择机构', trigger: 'change' }],
        deptid: [{ required: true, message: '请选择院系/部门', trigger: 'change' }],
        special: [{ max: 20, message: '最多不超过20个字符', trigger: 'blur' }],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        useridentity: [{ required: true, message: '请选择身份', trigger: 'change' }],
        studentno: [
          { required: false, message: '请输入学工号/校园卡号', trigger: 'blur' },
        ],
        position: [{ max: 20, message: '最多不超过20个字符', trigger: 'blur' }],
        contactphone: [{ validator: validateConsultphone, trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'blur' }],
      },
    }
  },
  components: {},
  computed: {
    // 判断是否已经修改过了
    checkIsChanged() {
      if (this.ruleForm.registerstep == '1') {
        return false
      } else if (this.ruleForm.registerstep == '2') {
        return true
      } else {
        return true
      }
    },
  },
  created() {},
  mounted() {
    this.getUserDataByRuid()
    this.getCustomerType()
    this.loading = true
  },
  methods: {
    handleCustomerTypeChange(val) {
      this.ruleForm.customercode = ''
      this.ruleForm.deptid = ''
      this.getCustomer(val, '')
    },
    handleCustomerChange(val) {
      this.ruleForm.deptid = ''
      this.getDepartment(val)
    },
    handleSelectFocus() {
      this.loading = true
      this.getUserCustomer(this.ruleForm.customercode)
    },
    // 出版社远程搜索
    remoteMethod(query) {
      this.loading = true
      this.getCustomer(this.ruleForm.customertype, query)
    },
    // 获取用户信息
    getUserDataByRuid() {
      let userruid = localStorage.getItem('userruid')
      if (userruid == null) {
        // this.$message.error("未登录，请先登录")
        // userruid="1786dd54013f001"
        return
      }
      let url = '/api/v1/platform/user/objectlist'
      let posBody = {
        field:
          'ruid,avatar,birthday,customercode,customertype,deptid,contactphone,email,useridentity,departmentinfoext,gender,jbruid,name,qq,registerstep,special,position,siteid,status,studentno,tel,userid,wechatid,type',
        filter: {
          itemList: [
            {
              fieldName: 'ruid',
              logicalOperator: 'and',
              relationOperator: 'equal',
              searchWord: userruid,
            },
          ],
        },
        pageno: 0,
        pagesize: 999,
        type: 'user',
      }
      this.$http({
        url: url,
        method: 'POST',
        data: posBody,
      }).then((res) => {
        if (res.cxajaxrc == 0 && res.returnvalue.recordcount == 1) {
          this.ruleForm = Object.assign(this.ruleForm, res.returnvalue.recordlist[0])
          // 如果机构类型不为空，将值转换为数值类型，机构类型下拉数据是数值型
          // 其实新用户的机构是默认为1的暂无机构
          if (this.ruleForm.customertype != '') {
            this.ruleForm.customertype = parseInt(this.ruleForm.customertype)
            // 获取机构类型获取机构
            // this.getCustomerType(this.ruleForm.type,'')
          }
          if (this.ruleForm.customercode != '') {
            this.getUserCustomer(this.ruleForm.customercode)
          }
        }
      })
    },
    // 获取机构类型
    getCustomerType() {
      let url = '/api/v1/platform/DataModel/objectlist'
      let postBody = {
        pageno: 0,
        pagesize: 10,
        type: 'customer_type',
        filter: {
          itemList: [
            {
              fieldName: 'name',
              relationOperator: 'like',
              searchWord: '',
            },
          ],
        },
        field: '',
        order: {
          itemList: [
            {
              asc: true,
              fieldName: 'orderno',
              valueType: 'N',
            },
          ],
        },
      }
      this.$http({
        url: url,
        method: 'POST',
        data: postBody,
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          const list = res.returnvalue.recordlist.filter((item) => item.code == 1)
          list.push({ name: '请选择', code: 4, orderno: 4 })
          this.customerTypeData = list
        }
      })
    },
    // 获取当前用户绑定的机构
    getUserCustomer(customercode) {
      let url = '/api/v1/platform/customer/objectlist'
      let postBody = {
        pageno: 0,
        pagesize: 10,
        type: 'customer',
        filter: {
          itemList: [
            {
              fieldName: 'customercode',
              relationOperator: 'in',
              searchWord: customercode,
            },
            {
              fieldName: 'type',
              relationOperator: 'in',
              searchWord: this.ruleForm.customertype,
            },
          ],
        },
        field: '',
        order: {},
      }
      this.$http({
        url: url,
        method: 'POST',
        data: postBody,
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          this.cacheCustomerData = res.returnvalue.recordlist
          let url = '/api/v1/platform/customer/objectlist'
          let postBody = {
            pageno: 0,
            pagesize: 10,
            type: 'customer',
            filter: {
              itemList: [
                {
                  fieldName: 'customercode',
                  relationOperator: 'notin',
                  searchWord: customercode,
                },
                {
                  fieldName: 'type',
                  relationOperator: 'in',
                  searchWord: this.ruleForm.customertype,
                },
              ],
            },
            field: '',
            order: {},
          }
          this.$http({
            url: url,
            method: 'POST',
            data: postBody,
          }).then((res) => {
            if (res.cxajaxrc == 0) {
              this.loading = false
              this.customerData = res.returnvalue.recordlist
              this.customerData = this.cacheCustomerData.concat(this.customerData)
              this.getDepartment(this.ruleForm.customercode)
            }
          })
        }
      })
    },
    // 根据类型和搜索获取机构
    getCustomer(type, name) {
      let url = '/api/v1/platform/customer/objectlist'
      let postBody = {
        pageno: 0,
        pagesize: 10,
        type: 'customer',
        filter: {
          itemList: [
            {
              fieldName: 'name',
              relationOperator: 'like',
              searchWord: name,
            },
            {
              fieldName: 'type',
              relationOperator: 'in',
              searchWord: type,
            },
          ],
        },
        field: '',
        order: {},
      }
      this.$http({
        url: url,
        method: 'POST',
        data: postBody,
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          this.loading = false
          this.customerData = res.returnvalue.recordlist
        }
      })
    },
    // 获取院系部门
    getDepartment(val) {
      let url = '/api/v1/platform/department/objecttree'
      let postBody = {
        type: 'department',
        rootnode: {
          ruid: 'dep' + val,
        },
        deep: -1,
        field: '',
        filter: null,
        order: {
          itemList: [
            {
              asc: true,
              fieldName: 'orderno',
              valueType: 'L',
            },
          ],
        },
      }
      this.$http({
        url: url,
        method: 'POST',
        data: postBody,
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          this.departmentData = res.returnvalue
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = '/api/v1/user/register/bindinginstitution'
          let postBody = this.ruleForm
          this.$http({
            url: url,
            method: 'POST',
            data: postBody,
          }).then((res) => {
            if (res.cxajaxrc == 0) {
              this.$message.success('提交成功')
              this.updateUserInfo()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateUserInfo() {
      this.$http({
        url: `/api/v1/platform/user/getUserInfo?userRuid=${localStorage.getItem(
          'userruid'
        )}`,
        method: 'GET',
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          localStorage.setItem('userdata', JSON.stringify(res.returnvalue))
          localStorage.setItem('customercode', res.returnvalue.customercode)
          localStorage.setItem('customerCode', res.returnvalue.customercode)
          localStorage.setItem('isOtherOrg', false)
          this.$store.commit('customercodeStore', res.returnvalue.customercode)
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
main {
  width: 1200px;
  align-self: center;
}
::v-deep .el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 16px;
}
::v-deep .el-form-item__label {
  font-size: 16px !important;
}
.el-button {
  border-radius: 0px;
  font-size: 16px;
}
::v-deep .el-input__inner {
  border-radius: 0px !important;
  min-height: 42px !important;
  font-size: 16px;
}
.content {
  box-shadow: $mainShadow;
  margin-bottom: 30px;
  padding: 20px 0 40px 0;
  background: #ffffff;
  .tip {
    margin-bottom: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
  }
  .formarea {
    width: 620px;
    margin: 0 auto;
  }
}
.submit-button {
  padding: 10px 40px;
}
</style>
